<script lang="ts">
  import Lead from "$lib/Lead.svelte";
  import type { PortableTextBlock } from "@portabletext/types";
  import MetaData from "$lib/MetaData.svelte";
  import ArticlePage from "$lib/ArticlePage.svelte";

  interface Props {
    data: {
      page: {
        title: string;
        lead: string;
        content: PortableTextBlock[];
      };
    };
  }

  let { data }: Props = $props();
</script>

<MetaData
  data={{
    title: data?.page?.title,
    description: data?.page?.lead,
  }}
/>

<ArticlePage content={data.page.content} center={true}>
  <div class="px-edge-x max-w-prose-edge-x mx-a">
    <h1>{data.page.title}</h1>
    <Lead>{data.page.lead}</Lead>
    <hr />
  </div>
</ArticlePage>
